import { Divider } from '../../Divider'
import { ProfileDocumentsWidgetContentImagesSkeleton } from '../ProfileDocumentsWidgetContentImagesSkeleton'
import { WidgetContentSkeleton } from '../WidgetContentSkeleton'

import * as styles from './ProfileDocumentsWidgetContentSkeleton.module.css'

function ProfileDocumentsWidgetContentSkeleton({
  className = styles.ProfileDocumentsWidgetContentSkeleton,
}) {
  return (
    <div className={className}>
      <ProfileDocumentsWidgetContentImagesSkeleton />
      <Divider className={styles.divider} />
      <WidgetContentSkeleton />
    </div>
  )
}

export default ProfileDocumentsWidgetContentSkeleton
